import { platform } from 'constants'
import React, { useState } from 'react'
import { Dimensions } from 'react-native'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'
import { TextInput } from 'widgets/TextInput'

import { useFeatureFlag } from 'contexts/FeatureFlagContext'

type ToggleFeatureFlagsModalProps = {
  onClose: () => void
}

export const ToggleFeatureFlagsModal = ({ onClose }: ToggleFeatureFlagsModalProps) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const flags = useFeatureFlag()

  const SECRET_PIN = 'admin@123$$'
  const [secretPin, setSecretPin] = useState('')
  const [secretPinError, setSecretPinError] = useState('')

  const handlePinInput = (value: string) => {
    setSecretPin(value)
    setSecretPinError('')
  }

  const handleCancel = () => {
    setSecretPinError('')
    setSecretPin('')
    onClose()
  }

  const handleConfirm = async () => {
    if (secretPin.toLocaleLowerCase() === SECRET_PIN) {
      setSecretPin('')
      setSecretPinError('')
      onClose()
      return
    }

    setSecretPinError('Invalid PIN')
  }

  return (
    <Box
      position='absolute'
      display='flex'
      width='100%'
      height={platform.IS_WEB ? '100%' : Dimensions.get('window').height - 200}
      align='center'
      padding='xl'
      justifyContent='center'
      backgroundColor='black75'
      zIndex={100}
    >
      <Box width='100%' padding='md' backgroundColor='white' borderRadius='md'>
        <Box>
          <Text align='center' color='black' fontSize='md'>
            {true
              ? 'Please enter the secret PIN to enable development features.'
              : 'Disable new feed?'}
          </Text>
        </Box>
        <Box margin='xl'>
          {true && (
            <TextInput
              textAlign='center'
              value={secretPin}
              error={secretPinError}
              onChange={() => handlePinInput}
            />
          )}
        </Box>
        <Box display='flex' flexDirection='row' justifyContent='space-around' align='center'>
          <Pressable onPress={handleCancel}>
            <Box
              justifyContent='center'
              align='center'
              width={140}
              height={40}
              borderRadius='lg'
              border={{ color: 'grey', width: 1 }}
            >
              <Text color='error' fontSize='md'>
                Cancel
              </Text>
            </Box>
          </Pressable>
          <Pressable onPress={handleConfirm}>
            <Box
              justifyContent='center'
              align='center'
              width={140}
              height={40}
              borderRadius='lg'
              border={{ color: 'grey', width: 1 }}
            >
              <Text color='black' fontSize='md'>
                Confirm
              </Text>
            </Box>
          </Pressable>
        </Box>
      </Box>
    </Box>
  )
}
